<template>
      <div class="message_sec">
                <template v-if="!callFromDetails">
                     <span class="message_info " v-if="trimcontent">
                  <p class="cursor-pointer"  @click="openDetailsPage(message)">{{ getTrimmedContent(message.message) }}</p>
                  </span>
                   <span class="message_info" v-if="!trimcontent"  v-html="checkProperty(message,'message')">
                
                  </span>
                </template>
                  <div class="message_lables xs-hidden"  @click="processLabels()" v-if="[50,51].indexOf(getUserRoleId)<=-1">
                    <div class="new_label_as">
                        <ul class="label_list" >
                        <li class="label_new">Labels</li>
                        <template v-if="checkProperty(message,'labels') && checkProperty(message,'labels','length')>0"> 
                            <template v-for="(item,index ) in message['labels'] ">
                                <li :style="{'background-color':item['color']}">
                                    {{checkProperty(item,'name')}} <em   @click="deleteLabel(item)">x</em>
                                </li>
                            </template>
                        </template>
                        <li class="p-0 add_li">
                                <vs-dropdown ref="addLabelDropdown" vs-custom-content vs-trigger-click class="cursor-pointer add_new_label" >  
                                    <span>+</span>
                                    <div class="tooltip_cnt">
                                        <p>Add Label</p>
                                    </div>
                                <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown actions-dropdown profileDropdown add_lebel_drpdwn"  >
                                    <span class="drpdwn_label">Label as:</span>
                                    <div class="search">
                                    <vs-input :key="'searchtxt'" icon-pack="feather" @input="filterLabels" icon="icon-search" v-model.lazy="searchtxt" placeholder="Search"
                                        class="is-label-placeholder" />
                                    </div>
                                    <VuePerfectScrollbar>
                                    <ul style="min-width: 9rem" class="profileMenu" >
                                        <template v-for="colr in filteredList">
                                            <li :style="{'background-color':colr['color']}">
                                                <vs-checkbox v-model="colr.selectedColor" @input="manageLabel">
                                                    {{checkProperty(colr,'name')}}
                                                </vs-checkbox>
                                            </li>
                                        </template>
                                    </ul>
                                    </VuePerfectScrollbar>
                                    <div class="btn_wrap"  v-if="!loadedFromDashBoard">
                                        <vs-button color="success" :disabled="loadingLabel" @click="openCreateLabel" class="save" type="filled"><img src="@/assets/images/main/create_label.svg"> Create New</vs-button>
                                    </div>
                                </vs-dropdown-menu>
                                </vs-dropdown>
                        </li>
                        </ul>
                        
                    </div>
                    <messageAssign :loadedFromDashBoard="loadedFromDashBoard"  :petition="petition" :callFromDetails="callFromDetails" @updateUserIds="updateUserIds" :message="message" />
                  </div>

                </div>
</template>
<script>
import selectField from "@/views/forms/fields/simpleselectOption.vue";
import messageAssign from "@/views/messages/messageAssign.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    props:{
        callFromDetailsCom:{
            type:Boolean,
            dafault:false
        },
        trimcontent:false,
        message:{
            type:Object,
            default:null
        },
        labelsList:{
            type:Array,
            default:[]
        },
        callFromDetails:{
            type:Boolean,
            dafault:false
        },
        petition:{
            type:Object,
            default:null
        },
        loadedFromDashBoard:{
          type:Boolean,
          default:false
        },
    },
    components:{
        messageAssign,
        selectField,
        VuePerfectScrollbar
    },
    data:()=>({
        openAssignPopup:false,
        assignedUser:null,
        textLabelsList:[],
        loadingLabel:false,
        filteredList:[],
        searchtxt:''
    }),
    mounted() { 
        this.searchtxt= ''
    },
    methods:{
        openDetailsPage(val){
            this.$emit('openDetailsPage', val)
        },
    getTrimmedContent(content) {
      // Strip HTML tags using a temporary element
      const tempElement = document.createElement("div");
      tempElement.innerHTML = content;
      const plainText = tempElement.textContent || tempElement.innerText || "";

      // Trim the content to 200 characters and add "..." if needed
      const trimmedText = plainText.length > 100 ? plainText.slice(0, 100) + "..." : plainText;

      return trimmedText;
    },
        deleteLabel(val){
            let payload={
                messageId:this.checkProperty(this.message,'_id'),
                labels:[],
                //updateRemoveLabel:true
            }
            let selectedList = [];
            selectedList = _.filter(this.message['labels'],(labeItd)=>{
                return labeItd['_id'] != val['_id']
            });
            payload['labels'] = selectedList;
            let path='/communication/manage-labels'
            this.$store.dispatch("commonAction", {'data':payload,'path':path}).then(response => {
                let obj={
                    labels:payload['labels'],
                    messageId:this.checkProperty(this.message,'_id')
                }
                this.$emit('updateLabels',obj);
                this.showToster({message:response.message ,isError:false});
            }).catch((err)=>{ })
           
        },
        filterLabels(){
             
            this.filteredList = [];
            let searchRegex = new RegExp(this.searchtxt, 'i');
            setTimeout(()=>{
                this.filteredList = _.filter(this.textLabelsList,(item)=>{
                    return searchRegex.test(item['name']);
                    // if(item['name'].includes(this.searchtxt) ){
                    //     return item
                    // }
                     
                })
                // this.filteredList = _.filter(this.textLabelsList, (item) => {
                //     return searchRegex.test(item['name']);
                // });
            })
           
        },
        updateUserIds(val){
            this.$emit('updateUserIds',val)
        },
        manageLabel(callFrom=false){
            let payload={
                messageId:this.checkProperty(this.message,'_id'),
                labels:[],
            }
            let selectedList = [] ;
            if(this.checkProperty(this.textLabelsList,'length')>0){
                _.forEach(this.textLabelsList,(item)=>{
                    if(item['selectedColor'] == true){
                        let findObj = _.find(selectedList, {'_id':item['_id']});
                        if(!findObj){
                            selectedList.push(item)
                        }
                        
                    }
                })
            }
            if(this.checkProperty(this.filteredList,'length')>0){
                _.forEach(this.filteredList,(item)=>{
                    if(item['selectedColor'] == true){
                        let findObj = _.find(selectedList, {'_id':item['_id']});
                        if(!findObj){
                            selectedList.push(item)
                        }
                    }else if(item['selectedColor'] == false){
                        let fndObj = _.find(this.textLabelsList, {'_id':item['_id']});
                        if(fndObj && fndObj['selectedColor']){
                            selectedList.splice(selectedList.indexOf(fndObj),1)
                        }
                    }
                })
                // selectedList = _.filter(this.filteredList,(item)=>{
                //     return item['selectedColor'] == true
                // })
            }
            this.searchtxt = ''
            payload['labels'] = selectedList;
            let path='/communication/manage-labels'
            this.$store.dispatch("commonAction", {'data':payload,'path':path}).then(response => {
                let obj={
                    labels:payload['labels'],
                    messageId:this.checkProperty(this.message,'_id'),
                    callFromDetails:this.callFromDetails
                }
                this.$emit('updateLabels',obj);
                this.showToster({message:response.message ,isError:false});
                if (this.$refs.addLabelDropdown) {
                    this.$refs.addLabelDropdown.$el.click();
                }
            }).catch((err)=>{ })
        },
        openCreateLabel(){
            // if (this.$refs.addLabelDropdown) {
            //         this.$refs.addLabelDropdown.$el.click();
            //     }
            this.$emit('openCreateLabel',this.message)
        },
        processLabels(){
            this.textLabelsList = [];
            this.filteredList =[];
            if(this.checkProperty(this.labelsList,'length')>0){
            let tempList = [];
            if(this.checkProperty(this.message,'labels') && this.checkProperty(this.message,'labels','length')>0){
                _.forEach(this.labelsList ,(obj)=>{
                    obj = Object.assign(obj,{'selectedColor':false});
                    _.forEach(this.message['labels'],(labelId)=>{
                        if(labelId['_id'] == obj['_id']){
                            obj['selectedColor'] = true;
                        }
                    })
                    tempList.push(obj);
                })
            }else{
                _.forEach(this.labelsList ,(obj)=>{
                    obj = Object.assign(obj,{'selectedColor':false});
                    tempList.push(obj);
                })
            }
            if(tempList && this.checkProperty(tempList,'length')>0){
                this.textLabelsList = _.cloneDeep(tempList);
                this.filteredList = _.cloneDeep(tempList);
            }
        }
        }
    }
}
</script>